module.exports = require("../../skeleton/Skeleton.vue");